<template>
<div>

  <div class="container p-5 rounded-1" style="background-color:#00115a">
       
    
<div v-if="isLoaded && isActivated && (timeToEnd > 0) && !isVoted "> 
  <div v-if="confirmAlertId != null">
    <div style="color:white"><strong>Do you want to vote for {{confirmAlertName}}?</strong></div> 
    <div class="d-grid gap-2 d-md-block">
        <button  @click="setConfirmAlert(null,'')" class="btn btn-light mb-1 mt-3 rounded-4" ><strong>Cancel</strong></button>
       <button  @click="vote(confirmAlertId)" class="btn btn-warning mb-1 mt-3 rounded-4" style="background-color:#f9ae00; color:white"><strong>Ok</strong></button>
    </div>
  </div>  
  <div v-else>  
          <div style="color:white"><strong>Select a candidate:</strong></div> 
 
 <div class="d-grid gap-2">

   <button v-for="(item, key) in members" :key="key"  @click="setConfirmAlert(key,item)" class="btn btn-warning mb-1 mt-3 rounded-4" style="background-color:#f9ae00; color:white"><strong>{{item}}</strong></button>

</div>
</div>
</div>

<div v-if="!isLoaded">
  <div class="spinner-border" role="status">
  <span class="visually-hidden">Loading...</span>
</div>

</div>
<div v-if="isLoaded && isActivated && timeToEnd<0 && !isVoted">
          <div style="color:white"><strong>Voting is over</strong></div> 

</div>
<div v-if="isVoted && isActivated">
          <div style="color:white"><strong>Thank you for your vote!</strong></div> 

</div>
<div v-if="isLoaded && !isActivated">
          <div style="color:white"><strong>Voting will begin shortly</strong></div> 
</div>
  </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'HomeView',
  components: {
    
  },
  data: function () {
return {
confirmAlertId: null, 
confirmAlertName: '', 
timeNow: Date.now(),  
interval: undefined
}
},
  mounted(){
    this.$store.dispatch('onLogin')
    this.$store.dispatch('loginAsAnon')
    //this.$store.dispatch('loadConf', 'home')
    this.interval = setInterval(this.loadTime, 1000);
    
  },
  methods:{
    vote(id){
      this.$store.dispatch('vote', id);
      setTimeout(() => {
            this.confirmAlertId = null;
            this.confirmAlertName = '';
        }, 2000);
      
    },
    setConfirmAlert(id, name){
      this.confirmAlertId = id;
      this.confirmAlertName = name;
    },
    loadTime(){
      this.timeNow = Date.now();
    }
  },
  computed:{
    members(){return this.$store.state.members},
    isLogged(){return this.$store.state.isLogged},
    timeToEnd(){return this.$store.state.endTime - this.timeNow},
    isVoted(){return this.$store.state.vote >= 0},
    isLoaded(){return this.$store.state.vote != undefined && this.isLogged},
    isActivated(){return this.$store.state.activated}
  }
}
</script>
